import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import './RecentReply.css';

export default class RecentReply extends Component {

  static propTypes = {
    data: PropTypes.object,
    index: PropTypes.number
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }


  render() {
    const { data, index } = this.props;
    return (
      <div className="recentReply">
        <div className="bold">
          { index + 1 }. { data.env } &nbsp;&nbsp;{ data.respToPaidMessage ? 'PAID' : 'FREE' } &nbsp;&nbsp;{ moment(data.createdAt).format('YYYY/MM/DD HH:mm:ss') }
        </div>
        <div className="bold">
          { data.recipientEmail } &nbsp;&nbsp;{ data.senderEmail }
        </div>
        <div className="ml-20">
          { data.text }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/stats/RecentReply.jsx